export default __webpack_public_path__ + "static/media/navigation-permanent.147c5f6d.png";